import { EmptyGuid } from './emptyGuid';
import { luscinia } from './luscinia';

class DynamicRequiredForm {
    private formInputs: HTMLInputElement[] = [];
    private requiredFormInputs: HTMLInputElement[] = [];
    private ajaxSelect2PContainerEls: HTMLInputElement[] = [];

    constructor(formInputNames: string[], requiredFormInputNames: string[]) {
        formInputNames.forEach((inputName) => {
            const input: HTMLInputElement = document.querySelector(`input[name="${inputName}"]`);
            this.formInputs.push(input);
            if (input.classList.contains('luscinia-ajax-select')) {
                this.ajaxSelect2PContainerEls.push(input);
            }
        });
        requiredFormInputNames.forEach((inputName) => {
            const input: HTMLInputElement = document.querySelector(`input[name="${inputName}"]`);
            this.requiredFormInputs.push(input);
        });
        this.addEventListeners();
        this.checkInputValues();
    }

    private addEventListeners(): void {
        this.ajaxSelect2PContainerEls.forEach((input) => {
            $(input).on('change', () => this.checkInputValues());
        });
        this.formInputs.forEach((input) => {
            ['input', 'focus', 'blur', 'change'].forEach((event) => {
                input.addEventListener(event, () => this.checkInputValues());
            });
        });
    }

    private checkInputValues(): void {
        let formHasInputValue: boolean = false;
        for (const input of this.formInputs) {
            if (input.value && input.value != EmptyGuid.value) {
                formHasInputValue = true;
                break;
            }
        }
        if (formHasInputValue) {
            this.setFieldsAsRequired();
        } else {
            this.setFieldsAsNotRequired();
        }
    }

    private setFieldsAsNotRequired() {
        this.requiredFormInputs.forEach((input) => {
            luscinia.removeErrors(input);
            const inputLabel: HTMLLabelElement = this.getInputLabel(input);
            if (inputLabel.classList.contains('required')) {
                inputLabel.classList.remove('required');
            }
        });
    }

    private setFieldsAsRequired() {
        this.requiredFormInputs.forEach((input) => {
            const inputLabel: HTMLLabelElement = this.getInputLabel(input);
            if (!inputLabel.classList.contains('required')) {
                inputLabel.classList.add('required');
            }
        });
    }

    private getInputLabel(input: HTMLInputElement) {
        const formGroup: HTMLDivElement = input.closest('.grid');
        const inputLabel: HTMLLabelElement = formGroup.querySelector('label');
        return inputLabel;
    }
}

luscinia.createDynamicRequiredForm = function (formInputNames: string[], requiredFormInputNames: string[]) {
    new DynamicRequiredForm(formInputNames, requiredFormInputNames);
};
